import React from 'react'

export default function ImageModal(props) {
    // console.log('Image Modal Props: ', props);
    return (
        <div className='modalDiv'>
            {/* <!-- Trigger the Modal --> */}
            <img className="modalImg" onClick={()=>{props.setActiveImage(props.src)}} src={props.src} alt={props.alt} title='Expand' style={{marginBottom: '8px'}}/>
            {/* <!-- The Modal --> */}
            <div id='myModal' className="modal" onClick={()=>{props.setActiveImage('')}} style={{display: props.modalToggle}}>
                {/* <!-- The Close Button --> */}
                <span className="close">&times;</span>
                {/* <!-- Modal Content (The Image) --> */}
                <img className="modal-content" id={props.src} src={props.src} alt={props.alt} style={{maxWidth: props.width}}/>
                {/* <!-- Modal Caption (Image Text) --> */}
                <div id="caption">{props.filename}</div>
            </div>
            {/* {props.editing && <button className='button' style={{marginLeft: '25.5%'}} onClick={()=>{props.deletePicture(props.type, props.parentId, props.id)}}>Delete</button>} */}
        </div>
    )
}